import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { saveAs, formatNumber } from '../../commons';

const TableHeader = ({ title, totalItens, download }) => {
  const { migrationId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handlerDownload = useCallback(() => {
    setLoading(true);
    setError(false);

    download.resource({
      migrationId
    })
      .then(({ data }) => saveAs(data, download.fileName))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  });

  return (
    <div className='table-header'>
      <h2 className='table-header__title'>{title}</h2>

      <div className='table-header__actions'>
        {download && totalItens > 0 && (
          <button
            className={`table-header__download${error ? ' table-header__download--error' : ''}`}
            disabled={loading}
            onClick={handlerDownload}
            title={`Baixar a listagem dos ${formatNumber(totalItens)} registros`}
          >
            {loading ? 'Baixando...' : error ? 'Erro — tentar novamente' : 'Baixar'}
          </button>
        )}

        <span className='table-header__count'>
          {formatNumber(totalItens)} registro(s)
        </span>
      </div>
    </div>
  )
}

export default TableHeader;
